// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_fluentui_font-icons-mdl2_lib_index_js-node_modules_fluentui_react-file-t-0f2e96":"ecc761f572cad143c289","src_taskpane_App_js":"648bae1c7667c38fc5c4"}[chunkId] + ".js";
};